
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2291_4551)","fill":"#fff"}},[_c('path',{attrs:{"d":"M6.75 9a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7.5a3 3 0 110 6 3 3 0 010-6zM15.75 7.5V5.25h-1.5V7.5H12V9h2.25v2.25h1.5V9H18V7.5h-2.25zM9.782 10.5H3.718A3.722 3.722 0 000 14.218V18h1.5v-3.782A2.22 2.22 0 013.718 12h6.064A2.22 2.22 0 0112 14.218V18h1.5v-3.782A3.723 3.723 0 009.782 10.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2291_4551"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    